export default "__VITE_ASSET__Cwq7y7tD__"